/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyOfficeItem } from '../../models/company-office-item';
import { CompanyOfficeUpdateDto } from '../../models/company-office-update-dto';

export interface OfficeControllerUpdateOffice$Params {
  id: number;
      body: CompanyOfficeUpdateDto
}

export function officeControllerUpdateOffice(http: HttpClient, rootUrl: string, params: OfficeControllerUpdateOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerUpdateOffice.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyOfficeItem;
      }>;
    })
  );
}

officeControllerUpdateOffice.PATH = '/company/office/{id}';
